
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chinese",
      function () {
        return require("private-next-pages/chinese/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chinese"])
      });
    }
  